import React from 'react';

const MenuIcon = ({ iconName, alt }) => {
  const iconPath = `/icons/menu/${iconName}.png`;
  
  return (
    <img 
      src={iconPath} 
      alt={alt}
      style={{
        width: '20px',
        height: '20px',
        objectFit: 'contain'
      }}
    />
  );
};

export default MenuIcon;